import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { usePermisos } from "../../context/PermisosContext";
import { toast } from "../toasts/toastStore";

// Guarda de autorizacion por modulo/accion, independiente de requireAuth
// (que solo valida que haya sesion). Usa GET /users/me/permisos via
// PermisosContext, que se sondea en vivo: si el admin le quita el permiso al
// usuario mientras esta en la pagina, `perm` pasa a false y aqui se le saca
// al inicio al instante. Mientras los permisos no han terminado de cargar
// (primer render tras login) deja pasar para no parpadear un bloqueo falso.
export default function RequireModulo({ modulo, accion = "consultar", children }) {
  const { perm, loaded } = usePermisos() || { perm: () => true, loaded: true };
  const denegado = loaded && !perm(modulo, accion);

  useEffect(() => {
    if (denegado) toast.warning("No tienes permiso para acceder a esta sección");
  }, [denegado]);

  if (denegado) return <Navigate to="/app/home" replace />;

  return children;
}
